import { useMemo } from 'react';
import { sortBy } from '../../util/arrays';
import { useTransactionEntryCategoryGroups } from './useTransactionEntryCategoryGroups';

export const useCategoryGroupOptions = () => {
    const { transactionEntryCategoryGroups } =
        useTransactionEntryCategoryGroups();

    return useMemo(() => {
        if (!transactionEntryCategoryGroups) return [];

        const options = transactionEntryCategoryGroups.map((categoryGroup) => ({
            label: categoryGroup.name,
            value: categoryGroup.id,
            iconName: categoryGroup.iconName,
        }));

        return sortBy(options, 'label', 'ASC');
    }, [transactionEntryCategoryGroups]);
};
